export class ClienteIndividualEntity{
    constructor(
        public Id?:number,
        public CiudadCodigo?:number,
        public Identificacion?:string,
        public ApellidoPaterno?:string,
        public ApellidoMaterno?:string,
        public Nombres?:string,
        public FechaNacimiento?:Date,
        public EstadoCivil?:number,
        public EmailPrincipal?:string,
        public EmailSecundario?:string,
        public NumeroHijos?:number,
        public CelularPrincipal?:string,
        public CelularSecundario?:string,
        public TelefonoCasa?:string,
        public TelefonoOficina?:string,
        public PersonaContacto?:string,
        public CelularContacto?:string,
        public CodProvinciaDomicilio?:number,
        public ProvinciaDomicilio?:string,
        public CiudadDomicilio?:string,
        public SectorDomicilio?:string,
        public CodCiudadDomicilio?:number,
        public CodSectorDomicilio?:number,
        public CallePrincipalDomicilio?:string,
        public NumeracionDomicilio?:string,
        public CalleSecundariaDomicilio?:string,
        public NombreEmpresa?:string,
        public ProvinciaTrabajo?:string,
        public CodProvinciaTrabajo?:number,
        public CiudadTrabajo?:string,
        public CodCiudadTrabajo?:number,
        public SectorTrabajo?:string,
        public CodSectorTrabajo?:number,
        public CallePrincipalTrabajo?:string,
        public NumeracionTrabajo?:string,
        public CalleSecundariaTrabajo?:string,
        public EstadoCivilNombre?:string,
        public EnvioCorrespondencia?:number
        ){}
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/datos_generales_individual_entity.ts